import React from 'react'

import { Outlet } from 'react-router-dom'

import { Container } from 'reactstrap'
import logoImage from 'assets/images/spot-buy-logo-120.jpg'
import logoTestEnvironmentImage from 'assets/images/spot-buy-logo-test-environment.jpg'

export default () => {
  const isProd = process.env.REACT_APP_ENV === 'production'
  const image = isProd ? logoImage : logoTestEnvironmentImage

  return (
    <React.Fragment>
      <header className="py-1 text-center paper paper-1 public login">
        {isProd ? (
          <div className="brand">
            <img src={image} alt="Oazo logo" />
          </div>
        ) : (
          <div className="dev-brand">
            <img src={image} alt="Oazo logo" />
          </div>
        )}
      </header>
      <Container id="login" fluid>
        <Outlet />
      </Container>
    </React.Fragment>
  )
}
